import confetti from "canvas-confetti";
import { useCallback } from "react";

export const useConfetti = () => {
  const fireConfetti = useCallback(() => {
    // First burst from left
    confetti({
      particleCount: 60,
      spread: 55,
      origin: { x: 0.2, y: 0.6 },
      colors: ['#3a8066', '#f97316', '#10b981', '#fbbf24', '#8b5cf6'],
    });

    // Second burst from right
    setTimeout(() => {
      confetti({
        particleCount: 60,
        spread: 55,
        origin: { x: 0.8, y: 0.6 },
        colors: ['#3a8066', '#f97316', '#10b981', '#fbbf24', '#8b5cf6'],
      });
    }, 150);
  }, []);

  const fireSuccessConfetti = useCallback(() => {
    // Center burst for success
    confetti({
      particleCount: 100,
      spread: 70,
      origin: { x: 0.5, y: 0.5 },
      colors: ['#3a8066', '#10b981', '#22c55e', '#86efac'],
    });
  }, []);

  return { fireConfetti, fireSuccessConfetti };
};
